import React from 'react';
import ViewMessage from '@components/ViewMessage';
import { ActionGroupsIcon } from '@repo/icons';
import { Key } from '@repo/components/tooltips';
import { useSelector } from 'react-redux';
import { selectGroupIsImporting } from '@repo/redux/actions/groups';

const StandardEmptyGroupMessage = () => (
  <ViewMessage
    icon={<ActionGroupsIcon hoverOpacity={false} />}
    headline="Add People"
    message={
      <>
        Add anyone to this group by
        <br />
        tapping <Key>+</Key> or typing <Key>A</Key>
      </>
    }
  />
);

const ImportEmptyGroupMessage = () => (
  <ViewMessage
    icon={<ActionGroupsIcon hoverOpacity={false} />}
    headline="Import in progress…"
    message={<>We'll let you know as soon as we're ready.</>}
  />
);

export default function EmptyGroup({ id }: { id: string }) {
  const isImporting = useSelector(selectGroupIsImporting(id));
  return isImporting ? <ImportEmptyGroupMessage /> : <StandardEmptyGroupMessage />;
}
